import React, { useState } from 'react';
import Lable from '../Label/LabelField';
const InputField = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  error,
  placeholder,
  as = 'input',
  rows = 4,
  ...rest
}) => {
  return (
    <div className="mb-3">
      {label && <Lable label={label} />}
      <div className="input-group">
         {as === 'textarea' ? (
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          className={`form-control`}
          placeholder={placeholder}
          rows={rows}
          {...rest}
        />
      ) : (
        <input
          type={type}
          className={`form-control`}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          {...rest}
        />
        )}

      </div>
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
};

export default InputField;
